// @ts-nocheck

import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createOurService } from "../../../features/ourServices"; // Assuming your action for room services
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";

const AddOurService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "", // Room service name
    description: "", // Single description for the room service
    photo: null, // Image for the room service
  });

  const [imagePreview, setImagePreview] = useState(null); // For image preview

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0], // Handle photo image change
      }));
      setImagePreview(URL.createObjectURL(e.target.files[0])); // For image preview
    }
  };

  const handleSubmit = () => {
    // Dispatch createRoomService with formData
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value); // Append name, description, photo
      }
    });

    dispatch(createOurService(formDataFinal))
      .then((res) => {
        toast.success("Room Service created successfully!"); // Assuming you have a toast function
        navigate('/our-service'); // Redirect to room service list or another page
      })
      .catch((err) => {
        console.log(err, "error");
        toast.error("An error occurred while creating the room service.");
      });
  };

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Add Room Service
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Name Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="name"
              placeholder="Enter the service name"
              value={formData.name}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Description Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Description
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="description"
              placeholder="Enter the service description"
              value={formData.description}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Photo Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Photo
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept="image/*"
              name="photo"
              onChange={handleImageChange}
              style={{ width: "100%" }}
            />
            {imagePreview && (
              <img src={imagePreview} alt="Preview" style={{ width: "150px", height: "150px", marginTop: "20px" }} />
            )}
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddOurService;
